export default "__VITE_ASSET__D9xD3MEZ__"